import { render } from "./ClockIcon.vue?vue&type=template&id=01adcd6b&scoped=true"
import script from "./ClockIcon.vue?vue&type=script&lang=js"
export * from "./ClockIcon.vue?vue&type=script&lang=js"

import "./ClockIcon.vue?vue&type=style&index=0&id=01adcd6b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01adcd6b"

export default script